<button
  #originRef
  (click)="showPopover()"
  [class.bg-hover]="dropdownOpen"
  class="button"
  mat-icon-button
  type="button">
  <mat-icon color="primary" svgIcon="mat:notifications_active"></mat-icon>
  <span *ngIf="unreadCount > 0" class="unread-count">{{notificationCount$}}</span>
</button>


